import { createAsyncThunk } from '@reduxjs/toolkit';
import { userStatus } from 'constants/AuthConstant';
import { loginService, registerService ,socialLoginService ,forgotPasswordService ,resetPasswordService } from 'services/authService';
import { persistAuthData, persistAuthFlow } from 'utils/utils';

export const loginUser = createAsyncThunk('auth/login', async (credentials, { rejectWithValue }) => {
  try {
    const data = await loginService(credentials);
    persistAuthData(data)
    return data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const registerUser = createAsyncThunk('auth/register', async (userData, { rejectWithValue }) => {
  try {
    const data = await registerService(userData);
    if(data?.user_status === userStatus.SUCCESS){
      persistAuthData(data)
    }
    return data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const socialLoginUser = createAsyncThunk(
  'auth/socialLoginUser',
  async (socialData, { rejectWithValue }) => {
    try {
      const data = await socialLoginService(socialData);
      persistAuthData(data)
      return data; // Adjust based on your API response structure
    } catch (error) {
      return rejectWithValue(error.response.data); // Adjust based on your API error response structure
    }
  }
);



export const forgotPassword = createAsyncThunk('auth/forgotPassword', async (payload, { rejectWithValue }) => {
  try {
    const data = await forgotPasswordService(payload);
    persistAuthFlow("forgot" , "forgotpassword" , true)
    return data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});


export const resetPassword = createAsyncThunk('auth/resetPassword', async ({payload ,query}, { rejectWithValue }) => {
  try {
    const data = await resetPasswordService(payload , query);
    return data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});
